import { $$, RM } from "./util.js";

export function initReveal() {
  const io =
    "IntersectionObserver" in window
      ? new IntersectionObserver(
          (es) => {
            es.forEach((e) => {
              if (e.isIntersecting) {
                e.target.classList.add("in");
                io.unobserve(e.target);
              }
            });
          },
          { rootMargin: "0px 0px -6% 0px", threshold: 0.05 }
        )
      : null;

  $$(".rv:not(.in), .draw:not(.in)").forEach((el) => {
    const r = el.getBoundingClientRect();
    if (!io || RM || (r.top < innerHeight && r.bottom > 0)) el.classList.add("in");
    else io.observe(el);
  });

  // Safety net: anything still hidden after 2.5s gets revealed.
  setTimeout(() => $$(".rv, .draw").forEach((el) => el.classList.add("in")), 2500);
}
